import React from "react";

import { AlertBannerContext } from "./AlertBannerContext";
import { useMeasuredElementHeight } from "./useMeasuredElementHeight";

export const AlertBannerProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { heightPx: bannerHeightPx, ref: bannerRef } =
    useMeasuredElementHeight<HTMLDivElement>();

  return (
    <AlertBannerContext.Provider value={{ bannerHeightPx, bannerRef }}>
      {children}
    </AlertBannerContext.Provider>
  );
};
